import { render, staticRenderFns } from "./SmTextConvertedToList.vue?vue&type=template&id=2b935701&scoped=true&"
import script from "./SmTextConvertedToList.vue?vue&type=script&lang=ts&"
export * from "./SmTextConvertedToList.vue?vue&type=script&lang=ts&"
import style0 from "./SmTextConvertedToList.vue?vue&type=style&index=0&id=2b935701&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b935701",
  null
  
)

export default component.exports